import React from 'react';
import {
  Box,
  Button,
  Checkbox,
  Fab,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  TextField,
  Autocomplete,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const optionsObiettivi = ["Cultura","Persone","Pianeta"]; 

const optionsMissioni = [
  "Attrattività","Competenze","Custodia","Partecipazione","Abitare","Lavoro","Educazione",
  "Comunità","Inclusione","Ricerca","Innovazione","Benessere","Sviluppo Territorio","Ambiente",
  "Direzione Learning","PAAS"]; 

const ProvenienzaRisorse2026 = ({
  checkboxState,
  dynamicFields,
  handleCheckboxChange,
  handleTextFieldChange,
  handleTextFieldChange2,
  handleTextFieldChange3,
  handleAddRow,
  handleRemoveRow,
  handleAutocompleteChange,
  handleAutocompleteChange2,
  optionsMissioniBoth,
  optionsTesoretto, 
  optionsLasciti,
  idSeduta,
  isDisabled =false,
}) => {
  return (
    <div style={{ display: 'flex', marginTop: '20px', width: '100%' }}>
         <FormControl component="fieldset" disabled={isDisabled} style={{
                        marginLeft: '10px', width: '100%', minWidth: '150px',border: '1px solid rgba(0, 0, 0, 0.23)', 
                        borderRadius: '4px', padding: '10px',
                        }}>
                      <FormLabel component="legend" 
                      style={{ 
                          fontSize: '12px',
                          fontWeight: '400',
                          lineHeight: '1.4375em',
                          //width: '100%',
                          //transform: 'translate(-22px, 0px) scale(0.75)',                           
                          //color: 'rgba(0, 0, 0, 0.6)', // Colore standard della TextField
                          color:'black',
                          //webkitTransform: 'translate(-22px, 0px) scale(0.75)',
                          display: 'block',                          
                          fontFamily: 'Roboto, Helvetica, sans-serif', // Font predefinito di MUI
                          paddingRight:'5px',
                          paddingLeft:'5px'
                      }}>
                        Provenienza Ipotesi Intervento €
                      </FormLabel>
                      <FormGroup>
                        <FormControlLabel control={<Checkbox  checked={checkboxState[0]}                          
                          onChange= {(event)=>handleCheckboxChange(0,event)} />} label="Risorse dell'anno" />
                        
                          {checkboxState[0] && dynamicFields[0].length>0  && (
                            <Box style={{ marginLeft: '40px' }}>
                              {dynamicFields[0].map((field, index) => (
                                //console.log("sssddeddd", field,index),
                              <Box key={index} style={{display: 'flex', alignItems: 'center',marginBottom: '10px',}}>
                                <Autocomplete options={idSeduta.replaceAll("-","")>20250500 ? optionsMissioniBoth : optionsMissioniBoth} value={field.origineValue ?? null}
                                    onChange={(e, value) => handleAutocompleteChange(0, index, value)}
                                    renderInput={(params) => (<TextField {...params} label="Missione" />)}style={{ marginRight: '10px', flex: 1 }}/>
                                <TextField value={field.importoValue} onChange={(e) =>handleTextFieldChange(0, index, e.target.value)}
                                    label="Importo" style={{ marginRight: '10px', flex: 1 }} />
                                    <Fab style={{ background:"#30720F"}} aria-label="add" onClick={() => handleAddRow(0)}> <AddIcon /> </Fab>
                                    <Fab style={{marginLeft:"5px",   background: "#BF2C0B",}}  aria-label="add" onClick={() => handleRemoveRow(0, index)}> <RemoveIcon /> </Fab>
                                
                                </Box>
                              ))}                        
                            </Box>
                          )}
                          {checkboxState[0] && dynamicFields[0].length==0 && (
                              <Box style={{ marginLeft: '40px' }}>                           
                                  <Button variant="outlined" color="primary" disabled={isDisabled}
                                  onClick={() => handleAddRow(0)} >
                                Aggiungi Risorse</Button>
                              </Box>
                          )}

                          <FormControlLabel control={<Checkbox checked={checkboxState[1]} onChange= {(event)=>handleCheckboxChange(1,event)} />} 
                              label="Accantonamenti" />
                              {checkboxState[1] && dynamicFields[1].length>0  && (
                                  <Box style={{ marginLeft: '40px' }}>
                                      {dynamicFields[1].map((field, index) => (                                          
                                          <Box key={index} style={{display: 'flex', alignItems: 'center',marginBottom: '10px',}}>
                                          <TextField value={field.numeroPraticaValue} onChange={(e) =>handleTextFieldChange2(1, index, e.target.value)}
                                              label="Numero di pratica" style={{ marginRight: '10px', flex: 1 }} />
                                          <TextField value={field.dataSedutaValue} onChange={(e) =>handleTextFieldChange3(1, index, e.target.value)}
                                              label="Data della seduta" style={{ marginRight: '10px', flex: 1 }} />
                                          <TextField value={field.importoValue} onChange={(e) =>handleTextFieldChange(1, index, e.target.value)}
                                              label="Importo" style={{ marginRight: '10px', flex: 1 }} />                                        
                                          <Fab style={{ background:"#30720F"}} aria-label="add" onClick={() => handleAddRow(1)}> <AddIcon /> </Fab>
                                          <Fab style={{marginLeft:"5px",   background: "#BF2C0B",}}  aria-label="add" onClick={() => handleRemoveRow(1, index)}> <RemoveIcon /> </Fab>                                
                                          </Box>
                                      ))}                        
                                  </Box>
                               )}
                            {checkboxState[1] && dynamicFields[1].length==0 && (
                            <Box style={{ marginLeft: '40px' }}>                           
                                <Button variant="outlined" color="primary"
                              onClick={() => handleAddRow(1)} >
                              Aggiungi Accantonamento</Button>
                            </Box>
                            )}
                                                    
                          <FormControlLabel control={<Checkbox  checked={checkboxState[2]}                          
                          onChange= {(event)=>handleCheckboxChange(2,event)} />} label="In attesa di destinazione" />
                        
                          {checkboxState[2] && dynamicFields[2].length>0  && (
                            //console.log("FFFFFF",checkboxState[2],dynamicFields[2]),
                            <Box style={{ marginLeft: '40px' }}>
                              {dynamicFields[2].map((field, index) => {
                              //console.log("GGGGGG",field);
                              const showSecondAutocompleteInAttesaDestinazione = field?.origineValue?.startsWith("fondi in attesa di destinazione")||field?.origineValue?.startsWith("Fondi in attesa di destinazione");                                              
                              const showSecondAutocompleteRiassorbimenti = field?.origineValue?.startsWith("riassorbimenti")||field?.origineValue?.startsWith("Riassorbimenti");                                              
                              return(
                              <Box key={index} style={{display: 'flex', alignItems: 'center',marginBottom: '10px',}}>
                                <Autocomplete options={optionsTesoretto} value={field?.origineValue?.split("#")[0] ?? ""}
                                    onChange={(e, value) => handleAutocompleteChange(2, index, value)}
                                    renderInput={(params) => (<TextField {...params} label="Fondi in attesa di destinazione" />)}style={{ marginRight: '10px', flex: 1 }}/>
                                 {showSecondAutocompleteRiassorbimenti && (
                                  console.log("TYT",field?.origineValue?.split("#")?.[1]),                                            
                                      <Autocomplete options={optionsObiettivi} value={field?.origineValue?.split("#")?.[1] ?? ""}
                                                  onChange={(e, value) =>
                                                    handleAutocompleteChange2(2, index, value)
                                                  }
                                                  renderInput={(params) => (
                                                    <TextField {...params} label="Obiettivo" />
                                                  )}
                                                  sx={{ mr: 1, flex: 1 }}
                                                />
                                    )}
                                     {showSecondAutocompleteInAttesaDestinazione && (
                                      console.log("YTY",field?.origineValue?.split("#")?.[1]),                                            
                                      <Autocomplete options={optionsMissioni} value={field?.origineValue?.split("#")?.[1] ?? ""}
                                                  onChange={(e, value) =>
                                                    handleAutocompleteChange2(2, index, value)
                                                  }
                                                  renderInput={(params) => (
                                                    <TextField {...params} label="Missione" />
                                                  )}
                                                  sx={{ mr: 1, flex: 1 }}
                                                />
                                    )}
                                <TextField value={field.importoValue} onChange={(e) =>handleTextFieldChange(2, index, e.target.value)}
                                    label="Importo" style={{ marginRight: '10px', flex: 1 }} />
                                    <Fab style={{ background:"#30720F"}} aria-label="add" onClick={() => handleAddRow(2)}> <AddIcon /> </Fab>
                                    <Fab style={{marginLeft:"5px",   background: "#BF2C0B",}}  aria-label="add" onClick={() => handleRemoveRow(2, index)}> <RemoveIcon /> </Fab>
                                
                                </Box>);
                              })}                        
                            </Box>
                          )}
                      
                          {checkboxState[2] && dynamicFields[2].length==0 && (
                              <Box style={{ marginLeft: '40px' }}>                           
                                  <Button variant="outlined" color="primary"
                                onClick={() => handleAddRow(2)} >
                                Aggiungi Risorse</Button>
                              </Box>
                          )}

                        {/*  DA QUI PER AGGIUNGERE I DUE BANDI
                        <FormControlLabel control={<Checkbox  checked={checkboxState[6]}                          
                              onChange= {(event)=>handleCheckboxChange(6,event)} />} label="Bando per lo Sviluppo Organizzativo" />
                        
                          {checkboxState[6] && dynamicFields[6].length>0  && (

                              <Box style={{ marginLeft: '40px' }}>
                                  {dynamicFields[6].map((field, index) => (                            
                                      <Box key={index} style={{display: 'flex', alignItems: 'center',marginBottom: '10px',}}>
                                          <TextField value={field.dataSedutaValue} onChange={(e) =>handleTextFieldChange3(6, index, e.target.value)}
                                              label="Data della seduta" style={{ marginRight: '10px', flex: 1 }} />
                                          <Autocomplete options={idSeduta.replaceAll("-","")>20250500 ? optionsMissioniBoth : optionsMissioniBoth} value={field.origineValue}
                                            onChange={(e, value) => handleAutocompleteChange(6, index, value)}
                                            renderInput={(params) => (<TextField {...params} label="Missione" />)}style={{ marginRight: '10px', flex: 1 }}/>
                                          <TextField value={field.importoValue} onChange={(e) =>handleTextFieldChange(6, index, e.target.value)}
                                            label="Importo" style={{ marginRight: '10px', flex: 1 }} />
                                          <Fab style={{ background:"#30720F"}} aria-label="add" onClick={() => handleAddRow(6)}> <AddIcon /> </Fab>
                                          <Fab style={{marginLeft:"5px",   background: "#BF2C0B",}}  aria-label="add" onClick={() => handleRemoveRow(6, index)}> <RemoveIcon /> </Fab>                                
                                    </Box>
                              ))}                        
                            </Box>
                          )}
                          {checkboxState[6] && dynamicFields[6].length==0 && (
                              <Box style={{ marginLeft: '40px' }}>                           
                                  <Button variant="outlined" color="primary"
                                onClick={() => handleAddRow(6)} >
                                Aggiungi Risorse</Button>
                              </Box>
                          )}

                        <FormControlLabel control={<Checkbox  checked={checkboxState[7]}                          
                              onChange= {(event)=>handleCheckboxChange(7,event)} />} label="Bando Next Generation We" />
                        
                          {checkboxState[7] && dynamicFields[7].length>0  && (

                              <Box style={{ marginLeft: '40px' }}>
                                  {dynamicFields[7].map((field, index) => (                            
                                      <Box key={index} style={{display: 'flex', alignItems: 'center',marginBottom: '10px',}}>
                                          <TextField value={field.dataSedutaValue} onChange={(e) =>handleTextFieldChange3(7, index, e.target.value)}
                                              label="Data della seduta" style={{ marginRight: '10px', flex: 1 }} />
                                          <Autocomplete options={idSeduta.replaceAll("-","")>20250500 ? optionsMissioniBoth : optionsMissioniBoth} value={field.origineValue}
                                            onChange={(e, value) => handleAutocompleteChange(7, index, value)}
                                            renderInput={(params) => (<TextField {...params} label="Missione" />)}style={{ marginRight: '10px', flex: 1 }}/>
                                          <TextField value={field.importoValue} onChange={(e) =>handleTextFieldChange(7, index, e.target.value)}
                                            label="Importo" style={{ marginRight: '10px', flex: 1 }} />
                                          <Fab style={{ background:"#30720F"}} aria-label="add" onClick={() => handleAddRow(7)}> <AddIcon /> </Fab>
                                          <Fab style={{marginLeft:"5px",   background: "#BF2C0B",}}  aria-label="add" onClick={() => handleRemoveRow(7, index)}> <RemoveIcon /> </Fab>                                
                                    </Box>
                              ))}                        
                            </Box>
                          )}
                          {checkboxState[7] && dynamicFields[7].length==0 && (
                              <Box style={{ marginLeft: '40px' }}>                           
                                  <Button variant="outlined" color="primary"
                                onClick={() => handleAddRow(7)} >
                                Aggiungi Risorse</Button>
                              </Box>
                          )}

A QUI PER AGGIUNGRE I DUE BANDI*/}


                          <FormControlLabel control={<Checkbox  checked={checkboxState[3]}                          
                            onChange= {(event)=>handleCheckboxChange(3,event)} />} label="Fondi per erogazioni (ex art 1 comma 44 legge 178/2020)" />
                          {checkboxState[3] && dynamicFields[3].length>0 && (
                            <Box style={{ marginLeft: '40px' }}>
                              {dynamicFields[3].map((field, index) => (                            
                              <Box key={index} style={{display: 'flex', alignItems: 'center',marginBottom: '10px',}}>                                
                                <TextField value={field.importoValue} onChange={(e) =>handleTextFieldChange(3, index, e.target.value)}
                                    label="Importo" style={{ marginRight: '10px', flex: 1 }} />                                                                    
                                </Box>
                              ))}                        
                            </Box>
                          )}
                         {checkboxState[3] && dynamicFields[3].length==0 && (
                              <Box style={{ marginLeft: '40px' }}>                           
                                  <Button variant="outlined" color="primary"
                                onClick={() => handleAddRow(3)} >
                                Aggiungi Risorse</Button>
                              </Box>
                          )}

                          <FormControlLabel control={<Checkbox  checked={checkboxState[4]}                          
                          onChange= {(event)=>handleCheckboxChange(4,event)} />} label="Risorse derivanti da credito d'imposta" />
                          {checkboxState[4] && dynamicFields[4].length>0 && (
                            <Box style={{ marginLeft: '40px' }}>
                              {dynamicFields[4].map((field, index) => (                            
                              <Box key={index} style={{display: 'flex', alignItems: 'center',marginBottom: '10px',}}>                                
                                <TextField value={field.importoValue} onChange={(e) =>handleTextFieldChange(4, index, e.target.value)}
                                    label="Importo" style={{ marginRight: '10px', flex: 1 }} />                                                                    
                                </Box>
                              ))}                        
                            </Box>
                          )}
                         {checkboxState[4] && dynamicFields[4].length==0 && (
                              <Box style={{ marginLeft: '40px' }}>                           
                                  <Button variant="outlined" color="primary"
                                onClick={() => handleAddRow(4)} >
                                Aggiungi Risorse</Button>
                              </Box>
                          )}
                          
                          <FormControlLabel control={<Checkbox  checked={checkboxState[5]}                          
                          onChange= {(event)=>handleCheckboxChange(5,event)} />} label="Risorse derivanti da Lasciti e Donazioni" />
                          {checkboxState[5] && dynamicFields[5].length>0 && (
                            <Box style={{ marginLeft: '40px' }}>
                              {dynamicFields[5].map((field, index) => (                                                                 
                              <Box key={index} style={{display: 'flex', alignItems: 'center',marginBottom: '10px',}}>                   
                                <Autocomplete options={optionsLasciti} value={field.origineValue ?? null}
                                   onChange={(e, value) => handleAutocompleteChange(5, index, value)}
                                  renderInput={(params) => (<TextField {...params} label="Lascito" />)}style={{ marginRight: '10px', flex: 1 }}/>                                    
                                <TextField value={field.importoValue} onChange={(e) =>handleTextFieldChange(5, index, e.target.value)}
                                    label="Importo" style={{ marginRight: '10px', flex: 1 }} />          
                                <Fab style={{ background:"#30720F"}} aria-label="add" onClick={() => handleAddRow(5)}> <AddIcon /> </Fab>
                                <Fab style={{marginLeft:"5px",   background: "#BF2C0B",}}  aria-label="add" onClick={() => handleRemoveRow(5, index)}> <RemoveIcon /> </Fab>                                                          
                                </Box>
                              ))}                        
                            </Box>
                          )}
                         {checkboxState[5] && dynamicFields[5].length==0 && (
                              <Box style={{ marginLeft: '40px' }}>                           
                                  <Button variant="outlined" color="primary"
                                onClick={() => handleAddRow(5)} >
                                Aggiungi Risorse</Button>
                              </Box>
                          )}
                          {/** 
                          <FormControlLabel control={<Checkbox  checked={checkboxState[8]}                          
                            onChange= {(event)=>handleCheckboxChange(8,event)} />} label="Sperimentazione e attuazione del Piano Strategico" />
                          {checkboxState[8] && dynamicFields[8].length>0 && (
                            <Box style={{ marginLeft: '40px' }}>
                              {dynamicFields[8].map((field, index) => (                            
                              <Box key={index} style={{display: 'flex', alignItems: 'center',marginBottom: '10px',}}>                                
                                <TextField value={field.importoValue} onChange={(e) =>handleTextFieldChange(8, index, e.target.value)}
                                    label="Importo" style={{ marginRight: '10px', flex: 1 }} />                                                                    
                                </Box>
                              ))}                        
                            </Box>
                          )}
                         {checkboxState[8] && (dynamicFields[8].length==0) && (
                              <Box style={{ marginLeft: '40px' }}>                           
                                  <Button variant="outlined" color="primary"
                                onClick={() => handleAddRow(8)} >
                                Aggiungi Risorse</Button>
                              </Box>
                          )}
                          */}
                      </FormGroup>
                    </FormControl>
    </div>
  );
};

export default ProvenienzaRisorse2026;